export default {
  roi_desc: 'ROI: Включает отправку на сервер объектов, обнаруженных только внутри интересующей области',
  rot_desc:
    'ROT: Включает детектирование и отслеживание объектов только внутри заданной прямоугольной области. Используйте данную опцию, чтобы уменьшить нагрузку на сервер'
};
